<template>
  <div class="osk-products-filters-size">
    <UikitList
      :title="filterInfo?.name"
      class="osk-products-filters-size__list"
    >
      <UikitListItem
        v-for="item in filterInfo?.values"
        :key="item.id"
        class="osk-products-filters-size__item"
        no-padding
        @click="handleClick(item)"
      >
        <span>
          {{ item.name }}
        </span>

        <UikitLabel
          :text="getLabel(item)"
          class="osk-products-filters-size__label"
          small
          bold
        />

        <UikitIcon
          name="ArrowRightMark"
          class="osk-products-filters-size__arrow"
        />
      </UikitListItem>
    </UikitList>

    <BusinessProductsFiltersSizesInfoDialog
      v-model="isShowSizeDialog"
      :category-size="categorySizeItem"
      :selected-values="sizes"
      :items-count="itemsCount"
      :loading="loading"
      :page="page"
      @update-filter="updateFilter"
      @close-all="emits('closeAll')"
      @apply="emits('apply')"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  ListValue, SizeFilter, CategorySize,
} from '~/restAPI/data-contracts';

const props = defineProps<{
  filterInfo: SizeFilter
  title?: string
  loading?: boolean
  itemsCount?: number
  page?: string
}>();

const emits = defineEmits<{
  (e: 'updateFilter', value?: ListValue[]): void,
  (e: 'closeAll'): void,
  (e: 'apply'): void,
}>();

const sizes = ref<ListValue[]>(genSelected());

const isShowSizeDialog = ref(false);
const categorySizeItem = ref<CategorySize>();

function genSelected() {
  return props.filterInfo?.selectedValues ?? [];
}

function handleClick(item: CategorySize) {
  categorySizeItem.value = item;
  isShowSizeDialog.value = true;
}

function getLabel(item: CategorySize) {
  const children = sizes.value.reduce((result, size) => {
    const child = item.sizesValue.values?.find((value) => value.id === size.id);

    if (child) {
      result.push(size);
    }

    return result;
  }, [] as ListValue[]);

  return children.length ? String(children.length) : '';
}

function updateFilter(list?: ListValue[]) {
  sizes.value = list ?? [];
}

watch(isShowSizeDialog, (value) => {
  if (!value) {
    categorySizeItem.value = undefined;
  }
});

watch(sizes, (list) => {
  emits('updateFilter', list);
});

watch(() => props.filterInfo, () => {
  sizes.value = genSelected();
});
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-products-filters-size {
  &__item {
    height: 52px;
    display: flex;
    align-items: center;
    padding: 0 16px !important;
  }

  &__label {
    margin-left: auto;

    & + .osk-products-filters-size__arrow {
      margin-left: $indent-compact;
    }
  }

  &__arrow {
    margin-left: auto;
    margin-right: -5px;
  }

  :deep(.osk-list__title) {
    font-weight: 700;
    font-size: 22px;
    line-height: 27px;

    @include media-query(lg-and-up) {
      @include font-style($font-size-heading, $line-height-heading, $font-weight-bold);
    }
  }
}
</style>
